module.exports = __webpack_public_path__ + "static/img/contract1.c0d4b48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contract1.png
// module id = zFi/
// module chunks = 1